import { useEffect } from 'react'
import { getCookie, setCookies } from 'cookies-next'
import { useRouter } from 'next/router'
import axios from 'axios'
import { useAtom } from 'jotai'
import {
  userContents,
  isSharedContent,
  isLoggedIn,
  userEmail,
} from '@/utils/op-types/store'

import { useEffectOnce } from 'react-use'

const ClientActions = ({ id, type }) => {
  const router = useRouter()

  const [getSharedContent, setSharedContent] = useAtom(isSharedContent)
  const [getUserContent, setUserContent] = useAtom(userContents)
  const [getLoggedInState, setLoggedInState] = useAtom(isLoggedIn)
  const [getUserEmail, setUserEmail] = useAtom(userEmail)

  useEffect(async () => {
    // check shareID - first
    if (router.query?.shareId) {
      setSharedContent(true)

      const getSharedUserContent = await axios.post(
        '/api/rest/get-user-content-by-id-universal',
        {
          contentId: router.query?.shareId,
        },
      )

      if (getSharedUserContent.data) {
        setUserContent(getSharedUserContent.data)
      } else {
        // nothing - found - ignore
        setSharedContent(false)
      }
    } else if (router.query?.autosignup) {
      if (validateEmail(router.query?.autosignup)) {
        setCookies('wl-email', router.query.autosignup)

        const signUpAndCheckContent = await axios.post(
          '/api/rest/signup-email-and-get-content-type',
          {
            email: router.query.autosignup,
            id: id,
            content: JSON.stringify(getUserContent),
            consent: true,
          },
        )

        if (signUpAndCheckContent.data) {
          setLoggedInState(true)
          setUserEmail(router.query.autosignup)

          if (signUpAndCheckContent.data?.content) {
            setUserContent(signUpAndCheckContent.data.content)
          }
        }
      }
    } else if (getCookie('wl-email')) {
      //  check cookie - get user content

      try {
        const getUserContentsByEmail = await axios.post(
          '/api/rest/get-user-content-by-email-universal',
          {
            id: id,
            email: getCookie('wl-email'),
          },
        )

        if (getUserContentsByEmail.data._id) {
          setLoggedInState(true)
          setUserEmail(getCookie('wl-email'))
          setUserContent(getUserContent.data?.user_data)
        }
      } catch (e) {
        console.error(
          e,
          e.response.status,
          'error getting user from collection',
        )
      }
    }
  }, [router.query])

  function validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  }

  return null
}

export default ClientActions
